import React, { useState } from 'react';
import { connect } from 'react-redux';
import I18n from '../../../blocks/localization';
import { Button, FormGroup, Input } from 'reactstrap';
import { RouteComponentProps } from 'react-router';
import { ErrorMessage, Formik } from 'formik';
import { resetPasswordValidationSchema } from '../../../blocks/validation/validationSchema';
import { resetPasswordActions } from '../../../store/account/actions';
import { ResetPasswordRequest } from '../../../models/account/reset-password/ResetPasswordRequest';
import ContentLayoutWithoutNavigation from '../../core/ContentLayoutWithoutNavigation';

type Props = typeof mapDispatchToProps & RouteComponentProps;

const ResetPassword = (props: Props) => {
    const [resetPasswordRequest] = useState<ResetPasswordRequest>({ password: '', confirmPassword: '' } as ResetPasswordRequest);

    const params = new URLSearchParams(props.location.search);
    const code = params.get('code');

    const handleFormSubmit = (resetPasswordRequest: ResetPasswordRequest) => {
        props.resetPassword({ ...resetPasswordRequest, code: code } as ResetPasswordRequest);
    }

    return (
        <ContentLayoutWithoutNavigation>
            <h1>{I18n.t('resetPassword.title')}</h1>

            <Formik
                validationSchema={resetPasswordValidationSchema}
                validateOnBlur
                initialValues={resetPasswordRequest}
                enableReinitialize
                onSubmit={(values) => handleFormSubmit(values)}>
                {({ handleChange, handleSubmit, values, errors, touched, setFieldTouched, isValid }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <FormGroup>
                                <Input type="password" name="password" onChange={handleChange} placeholder={I18n.t('resetPassword.form.password')}
                                    className={errors.password && touched.password ? ' is-invalid' : ''} />
                                <ErrorMessage name="password" component="div" className="invalid-feedback" />
                            </FormGroup>
                            <FormGroup>
                                <Input type="password" name="confirmPassword" onChange={handleChange} placeholder={I18n.t('resetPassword.form.confirmPassword')}
                                    className={errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : ''} />
                                <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                            </FormGroup>

                            <Button type="submit" size="lg" color="primary" onClick={handleSubmit}>{I18n.t('resetPassword.button')}</Button>
                        </form>
                    );
                }}
            </Formik>
        </ContentLayoutWithoutNavigation>
    );
}

const mapDispatchToProps = {
    resetPassword: resetPasswordActions.request
};

export default connect(null, mapDispatchToProps)(ResetPassword as any);
